import React from "react";
// import DamageImagePdf from "./DamageImagePdf";

import EachPagePdf from "./EachPagePdf"

interface Props {
	response: any[];
	inspectionId?: string;
}
const DamageImagePdf: React.FC<Props> = ({
	response = [],
	inspectionId,
}) => {
	// 🔹 Split into chunks of 2
	const chunkArray = (arr: any[], size: number) => {
		const result = [];
		for (let i = 0; i < arr.length; i += size) {
			result.push(arr.slice(i, i + size));
		}
		return result;
	};
	console.log('response', response);
	const pages = chunkArray(response, response?.[0]?.viewName === 'Mobile' ? 1: 2);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<div
					key={pageIndex}
					style={{ pageBreakAfter: "always" }}
				>
					<EachPagePdf 
						view = 'Passenger'
						fileName = 'Download'
						images = {pageData}
						damages={{}}
						user={{}}
						inspectionId={inspectionId}
						idx={pageIndex}
					/>
				</div>
			))}
		</>
	);
};

export default DamageImagePdf;
